import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { SuspenseFallback } from '../../components/SuspenseFallback'

const InvestigationPage = lazy(() =>
  import('../../features/investigation/InvestigationPage').then((m) => ({
    default: m.InvestigationPage,
  })),
)

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/investigations')({
  component: InvestigationsRoute,
})

function InvestigationsRoute() {
  return (
    <Suspense fallback={<SuspenseFallback message="Loading investigation board..." />}>
      <InvestigationPage />
    </Suspense>
  )
}
